/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mode_StreakInputs */

const bn_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্ট্রিক`)
};

const de_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strähne`)
};

const el_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ράβδωση`)
};

const en_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streak`)
};

const es_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Racha`)
};

const fr_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série`)
};

const hi_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`धारी`)
};

const hu_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csík`)
};

const id_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garis`)
};

const it_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strisciante`)
};

const ja_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストリーク`)
};

const ko_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`줄`)
};

const nl_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streep`)
};

const pl_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasemko`)
};

const pt_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onda`)
};

const ru_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полоса`)
};

const sv_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strimma`)
};

const tr_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rüzgâr gibi geçmek`)
};

const uk_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смуга`)
};

const vi_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vệt`)
};

const zh_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`条纹`)
};

const zh_hant_mode_streak = /** @type {(inputs: Mode_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`條紋`)
};

/**
* | output |
* | --- |
* | "Streak" |
*
* @param {Mode_StreakInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const mode_streak = /** @type {((inputs?: Mode_StreakInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mode_StreakInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_mode_streak(inputs)
	if (locale === "de") return de_mode_streak(inputs)
	if (locale === "el") return el_mode_streak(inputs)
	if (locale === "en") return en_mode_streak(inputs)
	if (locale === "es") return es_mode_streak(inputs)
	if (locale === "fr") return fr_mode_streak(inputs)
	if (locale === "hi") return hi_mode_streak(inputs)
	if (locale === "hu") return hu_mode_streak(inputs)
	if (locale === "id") return id_mode_streak(inputs)
	if (locale === "it") return it_mode_streak(inputs)
	if (locale === "ja") return ja_mode_streak(inputs)
	if (locale === "ko") return ko_mode_streak(inputs)
	if (locale === "nl") return nl_mode_streak(inputs)
	if (locale === "pl") return pl_mode_streak(inputs)
	if (locale === "pt") return pt_mode_streak(inputs)
	if (locale === "ru") return ru_mode_streak(inputs)
	if (locale === "sv") return sv_mode_streak(inputs)
	if (locale === "tr") return tr_mode_streak(inputs)
	if (locale === "uk") return uk_mode_streak(inputs)
	if (locale === "vi") return vi_mode_streak(inputs)
	if (locale === "zh") return zh_mode_streak(inputs)
	return zh_hant_mode_streak(inputs)
});